import React from 'react';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';

import { Button, WrapperFlex, ImportBox } from '@unimed-fesp/components';

// #region import componentes
import { WarningToast } from '../../molecules/Toast';
import LoagingFiles from '../../molecules/LoadingFiles';
import TemplateDownloadText from './TemplateDownloadText';
import RegrasImportMassaInicial from './RegrasImportMassaInicial';
// #endregion

import { IconLike, IconPrev, Container } from './styles';

import { shapeFile, customValidations } from '../../../utils/file';
import { Creators as ListaActions } from '../../../store/ducks/lista';

function UploadMassaInicial({
  handleVoltar,
  setListaFiles,
  file,
  handleValidar,
  progress,
}) {
  const dispatch = useDispatch();
  const { success } = useSelector((state) => state.lista.MassaInicial.post);

  function handleErros({ fileErrors, hasMaxQuantity }) {
    if (fileErrors.length > 0) {
      if (fileErrors[0].error.hasMaxSize) {
        toast.error(
          <WarningToast>
            O arquivo ultrapassou o limite máximo de 10mb
          </WarningToast>
        );
      } else if (fileErrors[0].error.hasValidExtension) {
        toast.error(
          <WarningToast>O arquivo enviado deve ser um .csv</WarningToast>
        );
      } else if (hasMaxQuantity) {
        toast.error(
          <WarningToast>Deve-se enviar apenas 1 arquivo</WarningToast>
        );
      }
    }
  }

  return (
    <>
      <WrapperFlex column flexWrap>
        <Container justifyCenter style={{ maxWidth: '100%' }}>
          {file ? (
            <LoagingFiles
              files={[file]}
              onClickCancel={() => {
                setListaFiles([]);
                dispatch(ListaActions.postArquivoMassaInicialRenew());
              }}
              canImport={success}
              handleProgress={() => (success ? 100 : progress)}
              maxLengthFileName={40}
              width={500}
            />
          ) : (
            <ImportBox
              contentText={<RegrasImportMassaInicial />}
              templateDownloadText={<TemplateDownloadText />}
              setListaFiles={setListaFiles}
              shapeFile={shapeFile}
              customValidations={(filesInput) =>
                customValidations(filesInput, 10000000, 1, ['csv'], handleErros)
              }
              maxWidth={430}
            />
          )}
        </Container>
        <WrapperFlex justifySpaceBetween marginTop={25} maxWidth={500}>
          <Button
            tipo="secondary"
            paddingBottom={8}
            paddingTop={8}
            paddingRight={8}
            paddingLeft={8}
            width={100}
            type="button"
            alignCenter
            justifyCenter
            onClick={() => {
              setListaFiles([]);
              handleVoltar();
            }}
            font="16px unimed_slabregular"
          >
            <IconPrev />
            voltar
          </Button>
          <Button
            tipo="primary"
            paddingBottom={8}
            paddingTop={8}
            paddingRight={8}
            paddingLeft={8}
            width={100}
            type="button"
            alignCenter
            justifyCenter
            disabled={!success}
            onClick={handleValidar}
            font="16px unimed_slabregular"
          >
            <IconLike />
            validar
          </Button>
        </WrapperFlex>
      </WrapperFlex>
    </>
  );
}

export default UploadMassaInicial;
